window.addEventListener('DOMContentLoaded', () => {
  const showSizeGuide = new URLSearchParams(window.location.search).get('sizeguide')
  const modal = document.getElementById('sizingGuideModal')
  const modalTriggerValue = 'sizing-guide-modal'

  if (!modal) return

  let focusReturnElement = null

  const closeButton = modal.querySelector('[global_popup_modal_close="sizing-guide-modal"]')

  function openSizeGuide (triggerElement = document.activeElement) {
    focusReturnElement = triggerElement
    if (!modal.open) modal.showModal()
    document.body.classList.add('is-modal-open')

    if (closeButton) {
      requestAnimationFrame(() => closeButton.focus())
    }

    window.BAO.Utils.pushToDataLayer('size_guide_open')
  }

  function closeSizeGuide () {
    if (modal.open) modal.close()
  }

  modal.addEventListener('close', () => {
    document.body.classList.remove('is-modal-open')
    if (focusReturnElement && typeof focusReturnElement.focus === 'function') {
      focusReturnElement.focus()
      focusReturnElement = null
    }
  })

  function isClickOutsidePanel (eventClick) {
    const modalInner = modal.querySelector('.modal__inner')
    if (!modalInner) return eventClick.target === modal
    if (modalInner.contains(eventClick.target)) return false
    const bounds = modalInner.getBoundingClientRect()
    const { clientX, clientY } = eventClick

    return clientX < bounds.left || clientX > bounds.right || clientY < bounds.top || clientY > bounds.bottom
  }

  modal.addEventListener('click', (eventClick) => {
    if (eventClick.detail === 0) return
    if (isClickOutsidePanel(eventClick)) closeSizeGuide()
  })

  document.body.addEventListener('click', (eventClick) => {
    const openTrigger = eventClick.target.closest('[global_popup_modal_open]')
    const closeTrigger = eventClick.target.closest('[global_popup_modal_close]')
    const openModal = openTrigger ? openTrigger.getAttribute('global_popup_modal_open') : null
    const closeModal = closeTrigger ? closeTrigger.getAttribute('global_popup_modal_close') : null

    if (openModal === modalTriggerValue) {
      openSizeGuide(openTrigger)
    }

    if (closeModal === modalTriggerValue) {
      closeSizeGuide()
    }
  })

  document.body.addEventListener('keydown', (eventKey) => {
    const trigger = eventKey.target.closest(`[global_popup_modal_open="${modalTriggerValue}"]`)
    if (!trigger) return
    if (trigger.tagName === 'BUTTON' || trigger.tagName === 'A') return
    if (eventKey.key === 'Enter' || eventKey.key === ' ') {
      eventKey.preventDefault()
      openSizeGuide(trigger)
    }
  })

  if (showSizeGuide !== null) {
    openSizeGuide()
  }
})
